import { useState, useRef, useEffect } from 'react';
import { getSimulatedReply } from '../data/aiCannedReplies';

function formatText(text) {
  return text.split('\n').map((line, i) => (
    <span key={i}>
      {line.split(/\*\*(.*?)\*\*/g).map((chunk, j) => (j % 2 === 1 ? <strong key={j}>{chunk}</strong> : chunk))}
      <br />
    </span>
  ));
}

export default function AiChatBox({ initialMessage, placeholder, inputValue, onInputConsumed }) {
  const [messages, setMessages] = useState([{ role: 'system', text: initialMessage }]);
  const [input, setInput] = useState('');
  const [typing, setTyping] = useState(false);
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  }, [messages, typing]);

  useEffect(() => {
    if (inputValue) {
      setInput(inputValue);
      onInputConsumed?.();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue]);

  const send = (text) => {
    const value = (text ?? input).trim();
    if (!value) return;
    setInput('');
    setMessages((m) => [...m, { role: 'user', text: value }]);
    setTyping(true);
    setTimeout(() => {
      setTyping(false);
      setMessages((m) => [...m, { role: 'system', text: getSimulatedReply(value) }]);
    }, 900 + Math.random() * 500);
  };

  return (
    <div className="ai-chat-box">
      <div className="ai-chat-messages" ref={scrollRef}>
        {messages.map((m, i) => (
          <div key={i} className={`ai-msg ${m.role}`}>
            <div className="ai-msg-ava">{m.role === 'user' ? 'ST' : <i className="fa-solid fa-robot" />}</div>
            <div className="ai-msg-bubble">{formatText(m.text)}</div>
          </div>
        ))}
        {typing && (
          <div className="ai-msg system">
            <div className="ai-msg-ava"><i className="fa-solid fa-robot" /></div>
            <div className="ai-typing"><span /><span /><span /></div>
          </div>
        )}
      </div>
      <div className="ai-chat-input">
        <input
          type="text"
          placeholder={placeholder}
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') send(); }}
        />
        <button className="btn btn-ai btn-sm" onClick={() => send()}><i className="fa-solid fa-paper-plane" /> Ask</button>
      </div>
    </div>
  );
}
